import { QuoteCurrencyListExceptUsdt } from '@flipster/utils/constants/currency';

import type { CarouselInfo } from './types';

export type MarketCarouselType =
  | 'openPosition'
  | 'holdings'
  | 'hotTradingPairs'
  | 'newListing'
  | 'topMover'
  | 'highVolume'
  | 'highFundingRate'
  | 'yourFrequentTrade'
  | (typeof QuoteCurrencyListExceptUsdt)[number];

const quoteCurrencyCarouselMapper = QuoteCurrencyListExceptUsdt.reduce(
  (acc, currency) => ({
    ...acc,
    [currency]: {
      title: `${currency} pairs`,
      seeAll: true,
      category: currency,
    },
  }),
  {},
) as Record<(typeof QuoteCurrencyListExceptUsdt)[number], CarouselInfo>;

export const CarouselMapper: Record<MarketCarouselType, CarouselInfo> = {
  openPosition: {
    title: 'Your open positions',
    seeAll: false,
  },
  holdings: {
    title: 'Your holdings',
    seeAll: false,
  },
  hotTradingPairs: {
    title: 'Hot trading pairs',
    seeAll: true,
    category: 'hotTradings',
  },
  newListing: {
    title: 'New listings',
    seeAll: true,
    category: 'newListings',
  },
  topMover: {
    title: 'Top movers',
    seeAll: true,
    category: 'priceChange24h',
  },
  highVolume: {
    title: 'High volume',
    sub: '(24h)',
    seeAll: true,
    category: 'volume',
    alertProps: {
      title: 'High volume',
      message: 'Shows a symbol list based on the 24-hour trading volume across the market. Volume is in USDT.',
      confirmText: 'OK',
    },
  },
  highFundingRate: {
    title: 'High funding rates',
    seeAll: true,
    category: 'absFundingRates',
    alertProps: {
      title: 'High funding rates',
      message:
        'This is a list of top 10 symbols with the highest funding rates in absolute value.\n\nYou may gain periodic profit at funding times for holding long(short) positions when funding rates are\nnegative(positive).',
      confirmText: 'OK',
    },
  },
  yourFrequentTrade: {
    title: 'Your frequent trades',
    seeAll: true,
    category: 'yourFrequentTrades',
  },
  ...quoteCurrencyCarouselMapper,
};
